export const IS_USER_AGENT_WITH_AVAILABLE_APP = /iPhone|iPad|iPod|Android/i.test(
  window.navigator.userAgent,
);

export const IS_IOS_USER = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);

export const IS_ANDROID_USER = /Android/i.test(window.navigator.userAgent);
